<template>
  <div class="layout-split">
    <account-settings-sidebar />
    <div class="layout-split-right br-3 mb-2">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <embed-domains-dialog />
  </div>
</template>

<script>
  import AccountSettingsSidebar from "@app2/modules/AccountSettings/Components/Sidebar";
  import EmbedDomainsDialog from "@app2/modules/AccountSettings/Components/Modals/Domains";
  import { handleSubscription } from '@app2/router/guards/subscription';

  export default {
    name: 'AccountSettings',
    metaInfo() {
      return {
        titleTemplate: `Membership.io | Account Settings | %s`
      }
    },
    components: {
      EmbedDomainsDialog,
      AccountSettingsSidebar
    },
    beforeRouteEnter(to, from, next) {
      handleSubscription(to, from, next);
    },
  }
</script>
